import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import productTreeManager from './product-tree-manager';
import productPriceManager from './product-price-manager';
import systemLog from './system-log.js'
const System = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
            <Route path={`${match.url}/system-log`} component={systemLog} />
            <Route path={`${match.url}/product-tree-manager`} component={productTreeManager} />
            <Route path={`${match.url}/product-price-manager`} component={productPriceManager} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default System;